<div class="row">
  <div class="col-12 mb-3">
    <b class="d-block info-credit-card">Información de pago</b>
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-material-design
      [control]="controlNumeroTarjeta"
      label="Número de la tarjeta"
      id="id-texto-numero-tarjeta"
      [enableCopyPaste]="true"
      [wasValidate]="submitted"
      [maxlength]="19"
      (handleBlur)="handleChangeNumeroTarjetaDeCredito($event)"
    ></lib-input-material-design>
  </div>
  <div class="col-12 col-lg-6 d-flex justify-content-between">
    <div class="flex-grow-1">
      <lib-input-material-design
        [control]="controlCodigoDeSeguridad"
        label="Código de seguridad"
        id="id-texto-codigo-seguridad"
        [enableCopyPaste]="true"
        [wasValidate]="submitted"
        [maxlength]="maxLengthCodigoDeSeguridad"
        inputType="number"
        [numberMaxlength]="maxLengthCodigoDeSeguridad"
      ></lib-input-material-design>
    </div>
    <div class="ml-3 d-none d-lg-block">
      <button
        type="button"
        placement="right"
        class="btn show-example-ccv"
        [ngbPopover]="explampleCcv"
        triggers="mouseenter:mouseleave"
      >
        <i class="fas fa-question-circle example-ccv"></i>
      </button>
      <ng-template #explampleCcv>
        <img src="./assets/images/cvv.png" alt="Ejemplo de ccv" />
      </ng-template>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-select-material-design
      [items]="MONTHS"
      [control]="controlExpirationMonth"
      label="Mes"
      id="id-lista-mes-expiracion"
      [wasValidate]="submitted"
    ></lib-input-select-material-design>
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-select-material-design
      [items]="YEARS"
      [control]="controlExpirationYear"
      label="Año"
      id="id-lista-anio-expiracion"
      [wasValidate]="submitted"
    ></lib-input-select-material-design>
  </div>
</div>
<div
  class="form-group"
  *ngIf="
    controlHabilitarRenovacionAutomatica &&
    contenido.mostrarBannerRenovacionAutomatica
  "
>
  <img
    class="mw-100 d-none d-sm-block mb-3 mb-lg-0"
    [src]="contenido.bannerRenovacionAutomatica.url"
    alt="Renovacion"
  />
  <img
    class="mw-100 d-block d-sm-none mb-3"
    [src]="contenido.bannerRenovacionAutomaticaMobile.url"
    alt="Renovacion mobile"
  />
  <a
    [href]="
      prismicUtil.convertHTMLAsText(
        contenido.urlCondicionesRenovacionAutomatica
      )
    "
    target="_blank"
    class="link-check-conditions mt-4 d-block"
  >
    Consulta las condiciones completas aquí.
  </a>
</div>
<hr class="my-3" />
<div *ngIf="controlHabilitarRenovacionAutomatica">
  <div class="row">
    <app-switch
      [label]="
        prismicUtil.convertHTMLAsText(contenido.textoRenovacionAutomatica)
      "
      idInput="id-caja-renovacion-automatica"
      [control]="controlHabilitarRenovacionAutomatica"
      (switchChange)="activarRenovacionAutomatica($event)"
    >
    </app-switch>
  </div>
</div>
<ng-content></ng-content>

<div class="row flex-column align-items-center">
  <h4 class="titulo-total-pago mb-3">
    Tu pago se realizará por un valor de
    {{ totalAPagar | currency: 'COP':'symbol-narrow':'0.0-0' }} pesos
  </h4>
  <div class="row align-items-start justify-content-center">
    <label class="my-md-1 mr-md-2 px-3 px-md-0 text-center">
      ¿En cuántas cuotas quieres pagar tu seguro?
    </label>
    <lib-input-select-material-design
      [items]="CANTIDAD_DE_CUOTAS"
      [control]="controlCantidadDeCuotas"
      label="Cuotas"
      id="id-lista-cuotas"
      [wasValidate]="submitted"
    ></lib-input-select-material-design>
  </div>
  <button class="d-block btn-pagar my-3">PAGAR</button>
</div>
